/*
 *
 * File JS Principale
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import 'lightgallery/css/lightgallery-bundle.min.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'scss/app.scss';
//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Inter:400,500,600,700&display=swap'],
    },
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//
import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();
smoothScroll();

//--------------------------------------------------------------------//
